import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6a3498ac = () => interopDefault(import('../pages/banners/index.vue' /* webpackChunkName: "pages/banners/index" */))
const _232cda5f = () => interopDefault(import('../pages/brands/index.vue' /* webpackChunkName: "pages/brands/index" */))
const _b8d09074 = () => interopDefault(import('../pages/checklist.vue' /* webpackChunkName: "pages/checklist" */))
const _43d37af2 = () => interopDefault(import('../pages/comments/index.vue' /* webpackChunkName: "pages/comments/index" */))
const _213251ba = () => interopDefault(import('../pages/data.vue' /* webpackChunkName: "pages/data" */))
const _31e1996c = () => interopDefault(import('../pages/events/index.vue' /* webpackChunkName: "pages/events/index" */))
const _74405970 = () => interopDefault(import('../pages/faqs/index.vue' /* webpackChunkName: "pages/faqs/index" */))
const _1fb14173 = () => interopDefault(import('../pages/finance-loans/index.vue' /* webpackChunkName: "pages/finance-loans/index" */))
const _66fe977a = () => interopDefault(import('../pages/leads/index.vue' /* webpackChunkName: "pages/leads/index" */))
const _f2ce2534 = () => interopDefault(import('../pages/loans/index.vue' /* webpackChunkName: "pages/loans/index" */))
const _2e58dfe9 = () => interopDefault(import('../pages/Login.vue' /* webpackChunkName: "pages/Login" */))
const _1f84e479 = () => interopDefault(import('../pages/managers/index.vue' /* webpackChunkName: "pages/managers/index" */))
const _6b64a0a6 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _348e3332 = () => interopDefault(import('../pages/pages/index.vue' /* webpackChunkName: "pages/pages/index" */))
const _68492f04 = () => interopDefault(import('../pages/partners/index.vue' /* webpackChunkName: "pages/partners/index" */))
const _ed0707cc = () => interopDefault(import('../pages/popups/index.vue' /* webpackChunkName: "pages/popups/index" */))
const _4424a9f7 = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _ab6b1512 = () => interopDefault(import('../pages/promo-accounts/index.vue' /* webpackChunkName: "pages/promo-accounts/index" */))
const _41b555df = () => interopDefault(import('../pages/promo-alepay/index.vue' /* webpackChunkName: "pages/promo-alepay/index" */))
const _a0428f1c = () => interopDefault(import('../pages/promo-cashes/index.vue' /* webpackChunkName: "pages/promo-cashes/index" */))
const _510f0b4a = () => interopDefault(import('../pages/promo-overview/index.vue' /* webpackChunkName: "pages/promo-overview/index" */))
const _5f924575 = () => interopDefault(import('../pages/promo-products/index.vue' /* webpackChunkName: "pages/promo-products/index" */))
const _4123e518 = () => interopDefault(import('../pages/promo-settings/index.vue' /* webpackChunkName: "pages/promo-settings/index" */))
const _9356b678 = () => interopDefault(import('../pages/qr-scanners/index.vue' /* webpackChunkName: "pages/qr-scanners/index" */))
const _38f538c4 = () => interopDefault(import('../pages/responsive.vue' /* webpackChunkName: "pages/responsive" */))
const _306cb004 = () => interopDefault(import('../pages/reviews/index.vue' /* webpackChunkName: "pages/reviews/index" */))
const _13e68da9 = () => interopDefault(import('../pages/role-permission/index.vue' /* webpackChunkName: "pages/role-permission/index" */))
const _3700eedc = () => interopDefault(import('../pages/stations/index.vue' /* webpackChunkName: "pages/stations/index" */))
const _251b9e76 = () => interopDefault(import('../pages/stores/index.vue' /* webpackChunkName: "pages/stores/index" */))
const _0501eca8 = () => interopDefault(import('../pages/transactions/index.vue' /* webpackChunkName: "pages/transactions/index" */))
const _1079d3cb = () => interopDefault(import('../pages/user-managers/index.vue' /* webpackChunkName: "pages/user-managers/index" */))
const _8cf5e758 = () => interopDefault(import('../pages/banners/create.vue' /* webpackChunkName: "pages/banners/create" */))
const _e0414bb0 = () => interopDefault(import('../pages/banners/setting.vue' /* webpackChunkName: "pages/banners/setting" */))
const _5b3a8fcd = () => interopDefault(import('../pages/category/create.vue' /* webpackChunkName: "pages/category/create" */))
const _48442ef6 = () => interopDefault(import('../pages/category/index.bk.vue' /* webpackChunkName: "pages/category/index.bk" */))
const _7f4d4da8 = () => interopDefault(import('../pages/category/index.bk2.vue' /* webpackChunkName: "pages/category/index.bk2" */))
const _3205ded2 = () => interopDefault(import('../pages/events/create.vue' /* webpackChunkName: "pages/events/create" */))
const _2ded4e53 = () => interopDefault(import('../pages/faqs/category/index.vue' /* webpackChunkName: "pages/faqs/category/index" */))
const _3b7f1f4e = () => interopDefault(import('../pages/faqs/create.vue' /* webpackChunkName: "pages/faqs/create" */))
const _0c859d92 = () => interopDefault(import('../pages/login/change-password.vue' /* webpackChunkName: "pages/login/change-password" */))
const _28e3bed8 = () => interopDefault(import('../pages/news/create.vue' /* webpackChunkName: "pages/news/create" */))
const _5c49fb40 = () => interopDefault(import('../pages/news/create_bk.vue' /* webpackChunkName: "pages/news/create_bk" */))
const _2d0d1622 = () => interopDefault(import('../pages/news/create_bk2.vue' /* webpackChunkName: "pages/news/create_bk2" */))
const _706f1eb2 = () => interopDefault(import('../pages/news/index_bk.vue' /* webpackChunkName: "pages/news/index_bk" */))
const _3db894da = () => interopDefault(import('../pages/notifications/create.vue' /* webpackChunkName: "pages/notifications/create" */))
const _0dcf9d92 = () => interopDefault(import('../pages/pages/create.vue' /* webpackChunkName: "pages/pages/create" */))
const _51741c00 = () => interopDefault(import('../pages/partners/create.vue' /* webpackChunkName: "pages/partners/create" */))
const _64715c38 = () => interopDefault(import('../pages/popups/create.vue' /* webpackChunkName: "pages/popups/create" */))
const _700c090e = () => interopDefault(import('../pages/products/register.vue' /* webpackChunkName: "pages/products/register" */))
const _a0ab0c56 = () => interopDefault(import('../pages/stations/orders.vue' /* webpackChunkName: "pages/stations/orders" */))
const _1ea2e093 = () => interopDefault(import('../pages/stations/register.vue' /* webpackChunkName: "pages/stations/register" */))
const _0876900c = () => interopDefault(import('../pages/stations/vehicles/index.vue' /* webpackChunkName: "pages/stations/vehicles/index" */))
const _06c294e7 = () => interopDefault(import('../pages/transactions/transactions-details/index.vue' /* webpackChunkName: "pages/transactions/transactions-details/index" */))
const _2674f053 = () => interopDefault(import('../pages/user-managers/create.vue' /* webpackChunkName: "pages/user-managers/create" */))
const _34b9abbe = () => interopDefault(import('../pages/user-managers/edit.vue' /* webpackChunkName: "pages/user-managers/edit" */))
const _911e726a = () => interopDefault(import('../pages/faqs/category/create.vue' /* webpackChunkName: "pages/faqs/category/create" */))
const _b6f2dbf8 = () => interopDefault(import('../pages/stations/vehicles/create.vue' /* webpackChunkName: "pages/stations/vehicles/create" */))
const _2149e6df = () => interopDefault(import('../pages/brands/models/model-details/create.vue' /* webpackChunkName: "pages/brands/models/model-details/create" */))
const _2581c61c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _6964d23c = () => interopDefault(import('../pages/brands/models/model-details/_id/edit.vue' /* webpackChunkName: "pages/brands/models/model-details/_id/edit" */))
const _112d45e5 = () => interopDefault(import('../pages/stations/vehicles/_id/index.vue' /* webpackChunkName: "pages/stations/vehicles/_id/index" */))
const _733c2bce = () => interopDefault(import('../pages/faqs/category/_id/edit.vue' /* webpackChunkName: "pages/faqs/category/_id/edit" */))
const _3c2fc179 = () => interopDefault(import('../pages/stations/vehicles/_id/create.vue' /* webpackChunkName: "pages/stations/vehicles/_id/create" */))
const _720c0cc7 = () => interopDefault(import('../pages/stations/vehicles/_id/edit.vue' /* webpackChunkName: "pages/stations/vehicles/_id/edit" */))
const _6810f891 = () => interopDefault(import('../pages/news/_id/index.vue' /* webpackChunkName: "pages/news/_id/index" */))
const _0a8b6130 = () => interopDefault(import('../pages/stores/_id/index.vue' /* webpackChunkName: "pages/stores/_id/index" */))
const _1a447393 = () => interopDefault(import('../pages/transactions/_id/index.vue' /* webpackChunkName: "pages/transactions/_id/index" */))
const _41553317 = () => interopDefault(import('../pages/banners/_id/edit.vue' /* webpackChunkName: "pages/banners/_id/edit" */))
const _4bb7bc50 = () => interopDefault(import('../pages/category/_id/edit.vue' /* webpackChunkName: "pages/category/_id/edit" */))
const _c62943d6 = () => interopDefault(import('../pages/events/_id/edit.vue' /* webpackChunkName: "pages/events/_id/edit" */))
const _2d166f91 = () => interopDefault(import('../pages/faqs/_id/edit.vue' /* webpackChunkName: "pages/faqs/_id/edit" */))
const _3983e405 = () => interopDefault(import('../pages/finance-loans/_id/view-detail.vue' /* webpackChunkName: "pages/finance-loans/_id/view-detail" */))
const _0b0b031c = () => interopDefault(import('../pages/loans/_id/disbursement.vue' /* webpackChunkName: "pages/loans/_id/disbursement" */))
const _f59f73c8 = () => interopDefault(import('../pages/loans/_id/paperwork.vue' /* webpackChunkName: "pages/loans/_id/paperwork" */))
const _53d1549b = () => interopDefault(import('../pages/news/_id/edit.vue' /* webpackChunkName: "pages/news/_id/edit" */))
const _1b5e2ac6 = () => interopDefault(import('../pages/news/_id/edit_bk.vue' /* webpackChunkName: "pages/news/_id/edit_bk" */))
const _57e41265 = () => interopDefault(import('../pages/news/_id/edit_bk2.vue' /* webpackChunkName: "pages/news/_id/edit_bk2" */))
const _2e9aa98c = () => interopDefault(import('../pages/pages/_id/edit.vue' /* webpackChunkName: "pages/pages/_id/edit" */))
const _1b19447a = () => interopDefault(import('../pages/partners/_id/edit.vue' /* webpackChunkName: "pages/partners/_id/edit" */))
const _4e1c54a7 = () => interopDefault(import('../pages/popups/_id/edit.vue' /* webpackChunkName: "pages/popups/_id/edit" */))
const _674d6358 = () => interopDefault(import('../pages/products/_id/preview.vue' /* webpackChunkName: "pages/products/_id/preview" */))
const _60ebfbac = () => interopDefault(import('../pages/promo-accounts/_id/edit.vue' /* webpackChunkName: "pages/promo-accounts/_id/edit" */))
const _75e4552f = () => interopDefault(import('../pages/stations/_id/edit.vue' /* webpackChunkName: "pages/stations/_id/edit" */))
const _5193d0fa = () => interopDefault(import('../pages/transactions/_id/view-detail.vue' /* webpackChunkName: "pages/transactions/_id/view-detail" */))
const _31dc1356 = () => interopDefault(import('../pages/user-managers/_id/edit.vue' /* webpackChunkName: "pages/user-managers/_id/edit" */))
const _69c607f4 = () => interopDefault(import('../pages/transactions/_id/credit/_loanId/index.vue' /* webpackChunkName: "pages/transactions/_id/credit/_loanId/index" */))
const _2b67440c = () => interopDefault(import('../pages/transactions/_id/e-contract/_eContractId/index.vue' /* webpackChunkName: "pages/transactions/_id/e-contract/_eContractId/index" */))
const _836919b4 = () => interopDefault(import('../pages/transactions/_id/finances/_loanId/index.vue' /* webpackChunkName: "pages/transactions/_id/finances/_loanId/index" */))
const _5426389a = () => interopDefault(import('../pages/transactions/_id/e-contract/_eContractId/paperwork/index.vue' /* webpackChunkName: "pages/transactions/_id/e-contract/_eContractId/paperwork/index" */))
const _25ff3855 = () => interopDefault(import('../pages/transactions/_id/finances/_loanId/disbursed.vue' /* webpackChunkName: "pages/transactions/_id/finances/_loanId/disbursed" */))
const _7b543d1e = () => interopDefault(import('../pages/transactions/_id/finances/_loanId/paperwork.vue' /* webpackChunkName: "pages/transactions/_id/finances/_loanId/paperwork" */))
const _0e53964d = () => interopDefault(import('../pages/transactions/_id/finances/_loanId/view-detail.vue' /* webpackChunkName: "pages/transactions/_id/finances/_loanId/view-detail" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/banners",
    component: _6a3498ac,
    name: "banners"
  }, {
    path: "/brands",
    component: _232cda5f,
    name: "brands"
  }, {
    path: "/checklist",
    component: _b8d09074,
    name: "checklist"
  }, {
    path: "/comments",
    component: _43d37af2,
    name: "comments"
  }, {
    path: "/data",
    component: _213251ba,
    name: "data"
  }, {
    path: "/events",
    component: _31e1996c,
    name: "events"
  }, {
    path: "/faqs",
    component: _74405970,
    name: "faqs"
  }, {
    path: "/finance-loans",
    component: _1fb14173,
    name: "finance-loans"
  }, {
    path: "/leads",
    component: _66fe977a,
    name: "leads"
  }, {
    path: "/loans",
    component: _f2ce2534,
    name: "loans"
  }, {
    path: "/Login",
    component: _2e58dfe9,
    name: "Login"
  }, {
    path: "/managers",
    component: _1f84e479,
    name: "managers"
  }, {
    path: "/news",
    component: _6b64a0a6,
    name: "news"
  }, {
    path: "/pages",
    component: _348e3332,
    name: "pages"
  }, {
    path: "/partners",
    component: _68492f04,
    name: "partners"
  }, {
    path: "/popups",
    component: _ed0707cc,
    name: "popups"
  }, {
    path: "/products",
    component: _4424a9f7,
    name: "products"
  }, {
    path: "/promo-accounts",
    component: _ab6b1512,
    name: "promo-accounts"
  }, {
    path: "/promo-alepay",
    component: _41b555df,
    name: "promo-alepay"
  }, {
    path: "/promo-cashes",
    component: _a0428f1c,
    name: "promo-cashes"
  }, {
    path: "/promo-overview",
    component: _510f0b4a,
    name: "promo-overview"
  }, {
    path: "/promo-products",
    component: _5f924575,
    name: "promo-products"
  }, {
    path: "/promo-settings",
    component: _4123e518,
    name: "promo-settings"
  }, {
    path: "/qr-scanners",
    component: _9356b678,
    name: "qr-scanners"
  }, {
    path: "/responsive",
    component: _38f538c4,
    name: "responsive"
  }, {
    path: "/reviews",
    component: _306cb004,
    name: "reviews"
  }, {
    path: "/role-permission",
    component: _13e68da9,
    name: "role-permission"
  }, {
    path: "/stations",
    component: _3700eedc,
    name: "stations"
  }, {
    path: "/stores",
    component: _251b9e76,
    name: "stores"
  }, {
    path: "/transactions",
    component: _0501eca8,
    name: "transactions"
  }, {
    path: "/user-managers",
    component: _1079d3cb,
    name: "user-managers"
  }, {
    path: "/banners/create",
    component: _8cf5e758,
    name: "banners-create"
  }, {
    path: "/banners/setting",
    component: _e0414bb0,
    name: "banners-setting"
  }, {
    path: "/category/create",
    component: _5b3a8fcd,
    name: "category-create"
  }, {
    path: "/category/index.bk",
    component: _48442ef6,
    name: "category-index.bk"
  }, {
    path: "/category/index.bk2",
    component: _7f4d4da8,
    name: "category-index.bk2"
  }, {
    path: "/events/create",
    component: _3205ded2,
    name: "events-create"
  }, {
    path: "/faqs/category",
    component: _2ded4e53,
    name: "faqs-category"
  }, {
    path: "/faqs/create",
    component: _3b7f1f4e,
    name: "faqs-create"
  }, {
    path: "/login/change-password",
    component: _0c859d92,
    name: "login-change-password"
  }, {
    path: "/news/create",
    component: _28e3bed8,
    name: "news-create"
  }, {
    path: "/news/create_bk",
    component: _5c49fb40,
    name: "news-create_bk"
  }, {
    path: "/news/create_bk2",
    component: _2d0d1622,
    name: "news-create_bk2"
  }, {
    path: "/news/index_bk",
    component: _706f1eb2,
    name: "news-index_bk"
  }, {
    path: "/notifications/create",
    component: _3db894da,
    name: "notifications-create"
  }, {
    path: "/pages/create",
    component: _0dcf9d92,
    name: "pages-create"
  }, {
    path: "/partners/create",
    component: _51741c00,
    name: "partners-create"
  }, {
    path: "/popups/create",
    component: _64715c38,
    name: "popups-create"
  }, {
    path: "/products/register",
    component: _700c090e,
    name: "products-register"
  }, {
    path: "/stations/orders",
    component: _a0ab0c56,
    name: "stations-orders"
  }, {
    path: "/stations/register",
    component: _1ea2e093,
    name: "stations-register"
  }, {
    path: "/stations/vehicles",
    component: _0876900c,
    name: "stations-vehicles"
  }, {
    path: "/transactions/transactions-details",
    component: _06c294e7,
    name: "transactions-transactions-details"
  }, {
    path: "/user-managers/create",
    component: _2674f053,
    name: "user-managers-create"
  }, {
    path: "/user-managers/edit",
    component: _34b9abbe,
    name: "user-managers-edit"
  }, {
    path: "/faqs/category/create",
    component: _911e726a,
    name: "faqs-category-create"
  }, {
    path: "/stations/vehicles/create",
    component: _b6f2dbf8,
    name: "stations-vehicles-create"
  }, {
    path: "/brands/models/model-details/create",
    component: _2149e6df,
    name: "brands-models-model-details-create"
  }, {
    path: "/",
    component: _2581c61c,
    name: "index"
  }, {
    path: "/brands/models/model-details/:id?/edit",
    component: _6964d23c,
    name: "brands-models-model-details-id-edit"
  }, {
    path: "/stations/vehicles/:id",
    component: _112d45e5,
    name: "stations-vehicles-id"
  }, {
    path: "/faqs/category/:id/edit",
    component: _733c2bce,
    name: "faqs-category-id-edit"
  }, {
    path: "/stations/vehicles/:id/create",
    component: _3c2fc179,
    name: "stations-vehicles-id-create"
  }, {
    path: "/stations/vehicles/:id/edit",
    component: _720c0cc7,
    name: "stations-vehicles-id-edit"
  }, {
    path: "/news/:id",
    component: _6810f891,
    name: "news-id"
  }, {
    path: "/stores/:id",
    component: _0a8b6130,
    name: "stores-id"
  }, {
    path: "/transactions/:id",
    component: _1a447393,
    name: "transactions-id"
  }, {
    path: "/banners/:id/edit",
    component: _41553317,
    name: "banners-id-edit"
  }, {
    path: "/category/:id?/edit",
    component: _4bb7bc50,
    name: "category-id-edit"
  }, {
    path: "/events/:id/edit",
    component: _c62943d6,
    name: "events-id-edit"
  }, {
    path: "/faqs/:id/edit",
    component: _2d166f91,
    name: "faqs-id-edit"
  }, {
    path: "/finance-loans/:id?/view-detail",
    component: _3983e405,
    name: "finance-loans-id-view-detail"
  }, {
    path: "/loans/:id/disbursement",
    component: _0b0b031c,
    name: "loans-id-disbursement"
  }, {
    path: "/loans/:id/paperwork",
    component: _f59f73c8,
    name: "loans-id-paperwork"
  }, {
    path: "/news/:id/edit",
    component: _53d1549b,
    name: "news-id-edit"
  }, {
    path: "/news/:id/edit_bk",
    component: _1b5e2ac6,
    name: "news-id-edit_bk"
  }, {
    path: "/news/:id/edit_bk2",
    component: _57e41265,
    name: "news-id-edit_bk2"
  }, {
    path: "/pages/:id/edit",
    component: _2e9aa98c,
    name: "pages-id-edit"
  }, {
    path: "/partners/:id/edit",
    component: _1b19447a,
    name: "partners-id-edit"
  }, {
    path: "/popups/:id/edit",
    component: _4e1c54a7,
    name: "popups-id-edit"
  }, {
    path: "/products/:id/preview",
    component: _674d6358,
    name: "products-id-preview"
  }, {
    path: "/promo-accounts/:id?/edit",
    component: _60ebfbac,
    name: "promo-accounts-id-edit"
  }, {
    path: "/stations/:id/edit",
    component: _75e4552f,
    name: "stations-id-edit"
  }, {
    path: "/transactions/:id/view-detail",
    component: _5193d0fa,
    name: "transactions-id-view-detail"
  }, {
    path: "/user-managers/:id?/edit",
    component: _31dc1356,
    name: "user-managers-id-edit"
  }, {
    path: "/transactions/:id/credit/:loanId",
    component: _69c607f4,
    name: "transactions-id-credit-loanId"
  }, {
    path: "/transactions/:id/e-contract/:eContractId",
    component: _2b67440c,
    name: "transactions-id-e-contract-eContractId"
  }, {
    path: "/transactions/:id/finances/:loanId",
    component: _836919b4,
    name: "transactions-id-finances-loanId"
  }, {
    path: "/transactions/:id/e-contract/:eContractId?/paperwork",
    component: _5426389a,
    name: "transactions-id-e-contract-eContractId-paperwork"
  }, {
    path: "/transactions/:id/finances/:loanId?/disbursed",
    component: _25ff3855,
    name: "transactions-id-finances-loanId-disbursed"
  }, {
    path: "/transactions/:id/finances/:loanId?/paperwork",
    component: _7b543d1e,
    name: "transactions-id-finances-loanId-paperwork"
  }, {
    path: "/transactions/:id/finances/:loanId?/view-detail",
    component: _0e53964d,
    name: "transactions-id-finances-loanId-view-detail"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
